<mat-form-field appearance="fill">
  <mat-label>Project neve</mat-label>
  <input matInput value="" [(ngModel)]="name">
</mat-form-field>
<div class="save-button">
  <app-button
    (click)="save()"
    [title]="'Mentés'"
    [customColor]="'green'"
  ></app-button>
</div>